export const NewsFilterJson = [
    {
        "id":"1",
        "label":"Brands",
        "name":"Brands"
    },
    {
        "id":"2",
        "label":"Business",
        "name":"Business"
    },
    {
        "id":"3",
        "label":"Community Impact",
        "name":"Community Impact"
    },
    {
        "id":"4",
        "label":"Sustainability",
        "name":"Sustainability"
    },
    {
        "id":"5",
        "label":"Clear All",
        "name":"Clear All"
    }
  ] 
export const BrandsData = [
    {
      categoryID: 1,
      id: 1,
      imageProps: {
        alt: '',
        height: 200,
        src: 'https://www.mondelezinternational.com/-/media/Mondelez/Our-Brands/Brands/Barni/Barni.png',
        width: 200
      },
      link: {
        gaEventClass: 'event_button_click',
        gaEventLabel: 'Back',
        imageType: 'regular',
        isAnchorTag: null,
        label: 'Back',
        name: 'page link',
        scrollToElementId: null,
        target: '_blank',
        title: '',
        url: 'https://www.mondelezinternational.com/About-Us/Leadership/Executive-Team/Dirk-Van-De-Put'
      },
      profileHoverSvg: '<svg className="hover-pic" height="269.103" viewBox="0 0 278.933 269.103" width="278.933" xmlns="http://www.w3.org/2000/svg"><path className="transparency-quarter" d="M248.113 214.161c28.407-39.978 60.015-107.017-19.678-181.441C200.335 6.48 76.506-37.054 20.7 60.473-13.038 119.442-6.747 196.7 48.515 240.649c58.019 46.136 155.643 35.364 199.6-26.488" data-name="Stroke 1 Copy 10" fill="#4f2170"/></svg>',
      profileSvg: '<svg className="shape-icon-pic" enableBackground="new 0 0 261.5 252.4" viewBox="0 0 261.5 252.4" x="0" xmlns="http://www.w3.org/2000/svg" y="0"><path className="bg-fill-white" d="M.4.4V252h260.8V.4H.4zm232 199.6c-41 57.7-132 67.7-186 24.7-51.5-41-57.4-113-25.9-167.9 52-90.9 167.4-50.3 193.6-25.9 74.3 69.3 44.8 131.8 18.3 169.1z"/><path className="bg-fill-transparent-border" d="M232 200.4c26.5-37.3 55.9-99.8-18.3-169.1C187.5 6.8 72.1-33.8 20.1 57.1c-31.5 55-25.6 127 25.9 167.9 54.1 43.1 145.1 33 186-24.6" stroke="#4f2170"/></svg>',
      title: 'Barni'
    },
    {
      categoryID: 2,
      id: 2,
      imageProps: {
        alt: '',
        height: 200,
        src: 'https://www.mondelezinternational.com/-/media/Mondelez/Our-Brands/Brands/5_Star/5Star.png',
        width: 200
      },
      link: {
        gaEventClass: 'event_button_click',
        gaEventLabel: 'Back',
        imageType: 'regular',
        isAnchorTag: null,
        label: 'Back',
        name: 'page link',
        scrollToElementId: null,
        target: '_blank',
        title: '',
        url: 'https://www.mondelezinternational.com/About-Us/Leadership/Executive-Team/Dirk-Van-De-Put'
      },
      profileHoverSvg: '<svg className="hover-pic" height="269.103" viewBox="0 0 278.933 269.103" width="278.933" xmlns="http://www.w3.org/2000/svg"><path className="transparency-quarter" d="M248.113 214.161c28.407-39.978 60.015-107.017-19.678-181.441C200.335 6.48 76.506-37.054 20.7 60.473-13.038 119.442-6.747 196.7 48.515 240.649c58.019 46.136 155.643 35.364 199.6-26.488" data-name="Stroke 1 Copy 10" fill="#4f2170"/></svg>',
      profileSvg: '<svg className="shape-icon-pic" enableBackground="new 0 0 261.5 252.4" viewBox="0 0 261.5 252.4" x="0" xmlns="http://www.w3.org/2000/svg" y="0"><path className="bg-fill-white" d="M.4.4V252h260.8V.4H.4zm232 199.6c-41 57.7-132 67.7-186 24.7-51.5-41-57.4-113-25.9-167.9 52-90.9 167.4-50.3 193.6-25.9 74.3 69.3 44.8 131.8 18.3 169.1z"/><path className="bg-fill-transparent-border" d="M232 200.4c26.5-37.3 55.9-99.8-18.3-169.1C187.5 6.8 72.1-33.8 20.1 57.1c-31.5 55-25.6 127 25.9 167.9 54.1 43.1 145.1 33 186-24.6" stroke="#4f2170"/></svg>',
      title: '5star'
    },
    {
      categoryID: 3,
      id: 3,
      imageProps: {
        alt: '',
        height: 200,
        src: 'https://www.mondelezinternational.com/-/media/Mondelez/Our-Brands/Brands/Barni/Barni.png',
        width: 200
      },
      link: {
        gaEventClass: 'event_button_click',
        gaEventLabel: 'Back',
        imageType: 'regular',
        isAnchorTag: null,
        label: 'Back',
        name: 'page link',
        scrollToElementId: null,
        target: '_blank',
        title: '',
        url: 'https://www.mondelezinternational.com/About-Us/Leadership/Executive-Team/Dirk-Van-De-Put'
      },
      profileHoverSvg: '<svg className="hover-pic" height="269.103" viewBox="0 0 278.933 269.103" width="278.933" xmlns="http://www.w3.org/2000/svg"><path className="transparency-quarter" d="M248.113 214.161c28.407-39.978 60.015-107.017-19.678-181.441C200.335 6.48 76.506-37.054 20.7 60.473-13.038 119.442-6.747 196.7 48.515 240.649c58.019 46.136 155.643 35.364 199.6-26.488" data-name="Stroke 1 Copy 10" fill="#4f2170"/></svg>',
      profileSvg: '<svg className="shape-icon-pic" enableBackground="new 0 0 261.5 252.4" viewBox="0 0 261.5 252.4" x="0" xmlns="http://www.w3.org/2000/svg" y="0"><path className="bg-fill-white" d="M.4.4V252h260.8V.4H.4zm232 199.6c-41 57.7-132 67.7-186 24.7-51.5-41-57.4-113-25.9-167.9 52-90.9 167.4-50.3 193.6-25.9 74.3 69.3 44.8 131.8 18.3 169.1z"/><path className="bg-fill-transparent-border" d="M232 200.4c26.5-37.3 55.9-99.8-18.3-169.1C187.5 6.8 72.1-33.8 20.1 57.1c-31.5 55-25.6 127 25.9 167.9 54.1 43.1 145.1 33 186-24.6" stroke="#4f2170"/></svg>',
      title: 'Barni'
    },
    {
      categoryID: 4,
      id: 4,
      imageProps: {
        alt: '',
        height: 200,
        src: 'https://www.mondelezinternational.com/-/media/Mondelez/Our-Brands/Brands/Barni/Barni.png',
        width: 200
      },
      link: {
        gaEventClass: 'event_button_click',
        gaEventLabel: 'Back',
        imageType: 'regular',
        isAnchorTag: null,
        label: 'Back',
        name: 'page link',
        scrollToElementId: null,
        target: '_blank',
        title: '',
        url: 'https://www.mondelezinternational.com/About-Us/Leadership/Executive-Team/Dirk-Van-De-Put'
      },
      profileHoverSvg: '<svg className="hover-pic" height="269.103" viewBox="0 0 278.933 269.103" width="278.933" xmlns="http://www.w3.org/2000/svg"><path className="transparency-quarter" d="M248.113 214.161c28.407-39.978 60.015-107.017-19.678-181.441C200.335 6.48 76.506-37.054 20.7 60.473-13.038 119.442-6.747 196.7 48.515 240.649c58.019 46.136 155.643 35.364 199.6-26.488" data-name="Stroke 1 Copy 10" fill="#4f2170"/></svg>',
      profileSvg: '<svg className="shape-icon-pic" enableBackground="new 0 0 261.5 252.4" viewBox="0 0 261.5 252.4" x="0" xmlns="http://www.w3.org/2000/svg" y="0"><path className="bg-fill-white" d="M.4.4V252h260.8V.4H.4zm232 199.6c-41 57.7-132 67.7-186 24.7-51.5-41-57.4-113-25.9-167.9 52-90.9 167.4-50.3 193.6-25.9 74.3 69.3 44.8 131.8 18.3 169.1z"/><path className="bg-fill-transparent-border" d="M232 200.4c26.5-37.3 55.9-99.8-18.3-169.1C187.5 6.8 72.1-33.8 20.1 57.1c-31.5 55-25.6 127 25.9 167.9 54.1 43.1 145.1 33 186-24.6" stroke="#4f2170"/></svg>',
      title: 'Barni'
    }
  ]
  export const filterLabel = "Topics"